import MaterialPopover from '@mui/material/Popover'
import { styled } from '@mui/material/styles'
import './index.css'

const Popover = styled(MaterialPopover)((props) => ({
  '& .MuiPaper-root': {
    maxHeight: 150,
    borderRadius: props.style?.borderRadius || 4,
    boxShadow: props.style?.boxShadow || '0px 40px 80px -16px rgba(25, 21, 49, 0.16), 0px 12px 32px -8px rgba(25, 21, 49, 0.16), 0px 0px 1px 0px rgba(25, 21, 49, 0.16)',
    marginTop: props.style?.marginTop
  }
}))

export default Popover
